/* eslint-disable */
import jwtDecode from 'jwt-decode';
import { getStorage } from './localstorage';
import { ROLES } from '../constants';

const decodeJwt = (data) => {
  const decoded = jwtDecode(data);
  return decoded;
};

const getRole = () => {
  const token = getStorage('token') || '';
  const decodeToken = token ? decodeJwt(token) : '';
  const { role } = decodeToken;
  return role;
};

const getId = () => {
  const token = getStorage('token') || '';
  const decodeToken = token ? decodeJwt(token) : '';
  const { merchant_id } = decodeToken;
  return merchant_id;
};

const getMKey = () => {
  const token = getStorage('token') || '';
  const decodeToken = token ? decodeJwt(token) : '';
  const { mkey } = decodeToken;
  return mkey;
};

const getSystem = () => {
  const token = getStorage('token') || '';
  const decodeToken = token ? decodeJwt(token) : '';
  const { system } = decodeToken;
  return system;
};

const getEmail = () => {
  const token = getStorage('token') || '';
  const decodeToken = token ? decodeJwt(token) : '';
  const { email } = decodeToken;
  return email;
};

export { getId, getMKey, getSystem, getEmail };

export const checkAccessRights = (accessibleRole) => {
  const currentRole = getRole();
  if (
    accessibleRole === ROLES.USER_ROLE ||
    accessibleRole === ROLES.ADMINUSER_ROLE ||
    accessibleRole === ROLES.SUPER_ADMIN_ROLE
  ) {
    if (currentRole === accessibleRole) {
      return true;
    }
    return false;
  }

  return false;
};

export default checkAccessRights;
